import React from 'react'
import '../../App.css'
import { useNavigate } from 'react-router-dom'

const Blog = () => {
   const navigate = useNavigate()

   const seeAllBlogs = () =>{
      navigate('/blogs')
   }
  return (
    <div>
       <div className='blog_header'>
          <h1>Where possibilities begin</h1>
          <p>We’re a leading marketplace platform for learning and teaching online. Explore some of our most popular content and learn something new.</p>
       </div>
       <div className='blog_body'>
          <h1>Latest from our blog</h1>
          <p>Exploring the cutting-edge insights and updates on our blog</p>
          <button className='see_all_btn' 
            onClick={seeAllBlogs}
          >
              See all
          </button>
       </div>
    </div>
  )
}

export default Blog
